import type { TermsPageLocaleContent } from '../types'

export const termsPageEn: TermsPageLocaleContent = {
  dateLocale: 'en-GB',
  title: 'Terms of Use - Toolvance',
  description: 'Terms of use for Toolvance.',
  metadata: {
    ogTitle: 'Terms of Use - Toolvance',
    ogDescription: 'Terms of use for Toolvance.',
    robots: 'noindex',
  },
  content: {
    heading: 'Terms of Use',
    updatedLabel: 'Last updated',
    sections: [
      {
        heading: 'Disclaimer',
        body: 'Toolvance provides calculators for informational and educational purposes only. Results should not be used as the sole basis for engineering decisions. Always verify critical calculations with a qualified professional.',
      },
      {
        heading: 'No warranties',
        body: 'The calculators are provided "as is" without warranty of any kind. We make no representations as to accuracy, completeness, or suitability of any information on this website.',
      },
      {
        heading: 'Use at your own risk',
        body: 'You use the results of these calculators at your own risk. We accept no liability for any errors, omissions, or outcomes resulting from use of these tools.',
      },
      {
        heading: 'Intellectual property',
        body: 'The content and code of Toolvance is proprietary. You may use calculator results for personal or professional purposes but may not reproduce the website or its tools without permission.',
      },
    ],
  },
}
